<template>
  <div class="flex flex-col">
    <div
      class="flex w-full active:bg-blue100 py-2.5 text-left"
      v-for="tag in tags"
      :key="tag.key"
      @click="$emit('click-tag', tag)"
    >
      <div class="text-W4 text-[15px] leading-[19.5px]">＃{{ tag }}</div>
    </div>
  </div>
</template>

<script>
const TagList = {
  name: 'TagList',
  emits: ['click-tag'],
  props: {
    tags: Array,
  },
}
export default TagList
</script>
<style scoped></style>
